<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：默认页面显示区域
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-home" class="app-home" style="padding:0px 20px;">
		加载中 ...
	</div>
</template>

<script>
import { getQuery } from '../api/'

// 输出元素
export default {
	name: 'app-home',
	data() {
		return {
			tableData: [],
			// 弹窗类型 0 新增 ， 1 修改
			modalType: 0,
			search: '',
			// 当前返回的总行数
			total: 0,
			pageData: {
				page: 1,
				limit: 1,
			},
			orderData: {
				col: "iorder",
				direct: "asc",
			}
		}
	},
	mounted() {
		// 获得页面
		let params = {};
		let jres = getQuery("get","indexto",params);
		this.$router.push(jres.indexpage)
		//console.log(jres);
	}, 
	components: {
	},
	methods: {
	}
}   
</script>

<style lang="less" Scoped>
</style>